export default {
    cellSize: 5,
    borderWidth: 1,
    interval: 50,
    themes: {
        light: {
            fill: {
                alive: '#ddd',
                dead: '#fefefe',
            },
            outline: '#eee',
        },
        dark: {
            fill: {
                alive: '#373737',
                dead: '#222',
            },
            outline: '#1d1d1d',
        },
    },
};
